/* eslint-disable no-restricted-globals */
import * as Yup from 'yup'

/**
 * @typedef {Object} AdditionalFieldType
 * @property {string} type
 * @property {string} label
 * @property {string} [placeholder]
 * @property {function(): Record<string, any>} [configuration]
 * @property {Yup.Schema<any>} [schema]
 */
export const additionalFieldTypes = [
  {
    type: "text",
    label: "Free text",
    placeholder: '',
    schema: Yup.object({
      minLength: Yup.number()
        .required("Minimum length is required")
        .test(
          "minLength",
          "Minimum length must be less than maximum length",
          function (value) {
            const maxLength = this.resolve(Yup.ref("maxLength"));
            return !maxLength || value < maxLength;
          }
        ),
      maxLength: Yup.number()
        .max(200, "Maximum length is 200")
        .required("Maximum length is required"),
    }),
  },
  {
    type: "money",
    label: "Value US$",
    placeholder: "Insert value",
  },
  {
    type: "cpf",
    label: "CPF",
    placeholder: "000.000.000-00",
  },
  {
    type: "phone",
    label: "Phone",
    placeholder: "(00) 00000-0000",
  },
  {
    type: "select",
    label: "Select",
    configuration: () => ({
      options: [
        { id: self.crypto.randomUUID(), label: 'Valor 1', value: 'Valor 1' },
        { id: self.crypto.randomUUID(), label: 'Valor 2', value: 'Valor 2' },
      ],
      isMulti: false
    }),
    schema: Yup.object({
      options: Yup.array(
          Yup.object({
            id: Yup.string().uuid().required(),
            label: Yup.string().required(),
            value: Yup.string().required().test('unique', 'Option must be unique by value', function (value) {
              const [{ value: option }, { value: select }] = this.from

              return !select.options.some(opt => {
                if (opt.id === option.id) return false

                return opt.value === value
              })
            }),
          })
        )
        .min(1, 'At least one option is required')
        .required("At least one option is required"),
      isMulti: Yup.boolean().required("Is multi is required"),
    }),
  },
]
